/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
// HAS TO BE `.js` CAUSE MIRAGE DOESN'T HAVE TYPE FOR `association`
import faker from 'faker';
import { Factory, association } from 'miragejs';

const user = Factory.extend({
  id: () => faker.datatype.uuid(),
  first_name: () => faker.name.firstName(),
  last_name: () => faker.name.lastName(),
  username: () => faker.internet.userName(),
  password: () => faker.internet.password(),
  is_superuser: () => false,
  email: () => faker.internet.email(),
  is_staff: () => true,
  is_active: () => faker.datatype.boolean(),
  is_account_manager: () => faker.datatype.boolean(),
  can_switch_accounts: () => faker.datatype.boolean(),
  is_reseller: () => false,
  account: association(),
});

export default user;
